import { render, staticRenderFns } from "./FiltersMobile.vue?vue&type=template&id=f435ffa8&"
import script from "./FiltersMobile.vue?vue&type=script&lang=js&"
export * from "./FiltersMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports